import { ACT_NTF_CHANGE } from "./ActionTypes";
import NotificationsService from "../provider/notification/NotificationsService";
import {loading} from "./AppActions"
import MediaService from "../provider/media/MediaService";

/*** ACTIONS NOTIFICATIONS ******/
export function actionGetNotifications(succesCallback, errorCallback) {
    return (dispatch, getStore) => {
				loading(true)(dispatch, getStore)
        NotificationsService.getNotifications(getStore().app.app).then((response) => {
            dispatch({
                type:ACT_NTF_CHANGE,
                props: {notificationList:response}
						})
            succesCallback()
        }).catch(errorCallback)
        .finally(()=>{loading(false)(dispatch, getStore)})
    };
}

export function actionSaveNotification(notification, successCallback, errorCallback) {
    return (dispatch, getStore) => {
        loading(true)(dispatch, getStore)
        notification.tskRunDate=new Date(notification.tskRunDate).getTime()
        if(notification.tskParams && (!notification.tskParams.image || typeof notification.tskParams.image == 'string')){//Si tiene una url y no un archivo seleccionado con el componente
          if(notification.tskParams&&!notification.tskParams.image&&notification.tskParams.pathImg){
            MediaService.deleteFile(notification.tskParams.pathImg)
            delete notification.tskParams.pathImg
            delete notification.tskParams.nameImg
          }
          NotificationsService.saveNotification(getStore().app.app, notification).then((response) => {
            successCallback()
          }).catch(errorCallback)
          .finally(()=>{loading(false)(dispatch, getStore)})
        }else{ //Si tiene un archivo seleccionado por el componente
          
          MediaService.uploadFile(notification.tskParams.image, 'notifications', 'image').then(res => {
            if(notification.tskParams&&notification.tskParams.pathImg&&notification.tskParams.pathImg!=res.path){
              MediaService.deleteFile(notification.tskParams.pathImg)
            }
            notification.tskParams.image=res.downloadURL
            notification.tskParams.nameImg=res.filename
            notification.tskParams.pathImg=res.path
            NotificationsService.saveNotification(getStore().app.app, notification).then((response) => {
              successCallback()
            }).catch(errorCallback)
          }).catch(errorCallback)
          .finally(()=>{loading(false)(dispatch, getStore)})
        }
    };
}

export function actionDeleteNotification(notification, successCallback, errorCallback) {
  return (dispatch, getStore) => {
      loading(true)(dispatch, getStore)
      NotificationsService.deleteNotification(getStore().app.app, notification.id).then((response) => {
        if(notification.tskParams&&notification.tskParams.pathImg){
          MediaService.deleteFile(notification.tskParams.pathImg)
        }
        successCallback()
      }).catch(errorCallback)
      .finally(()=>{loading(false)(dispatch, getStore)})
  };
}

export function actionGetUsersNotified(notificationId,succesCallback, errorCallback) {
  return (dispatch, getStore) => {
      loading(true)(dispatch, getStore)
      NotificationsService.getUsersNotified(getStore().app.app,notificationId).then((response) => {
        succesCallback&&succesCallback(response)
      }).catch(errorCallback)
      .finally(()=>{loading(false)(dispatch, getStore)})
  };
}
/****** FIN ACTION NOTIFICATIONS +**********/




// WEBPACK FOOTER //
// ./src/actions/NotificationActions.js